import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Shop", path: "/shop" },
  { label: "About", path: "/about" },
  { label: "Journal", path: "/journal" },
  { label: "Challenge", path: "/challenge" },
  { label: "Tracker", path: "/tracker" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#F4F3F0]" : "bg-transparent"
      }`}
    >
      <nav className="w-full px-8 lg:px-16 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/cd5fb264-97ad-456c-b34b-2769ee1ae298.png"
            alt="10 Pages a Day"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                    scrolled
                      ? isActive
                        ? "text-[#3A5544]"
                        : "text-[#1A1A1A] hover:text-[#3A5544]"
                      : isActive
                      ? "text-[#6B9E8A]"
                      : "text-white/90 hover:text-white"
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* CTA */}
        <Link
          to="/challenge"
          className="hidden lg:inline-flex items-center gap-2 bg-[#3A5544] text-white text-sm font-medium px-5 py-2 rounded hover:bg-[#2D4238] transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          Join the Challenge
        </Link>

        {/* Mobile Hamburger */}
        <button
          className={`lg:hidden w-8 h-8 flex flex-col justify-center gap-1.5 cursor-pointer ${
            scrolled ? "text-[#1A1A1A]" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block h-0.5 w-6 transition-all duration-200 ${scrolled ? "bg-[#1A1A1A]" : "bg-white"} ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block h-0.5 w-6 transition-all duration-200 ${scrolled ? "bg-[#1A1A1A]" : "bg-white"} ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block h-0.5 w-6 transition-all duration-200 ${scrolled ? "bg-[#1A1A1A]" : "bg-white"} ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-[#F4F3F0] px-8 pb-6 pt-2">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`block text-sm font-medium tracking-wide cursor-pointer ${
                    location.pathname === link.path ? "text-[#3A5544]" : "text-[#1A1A1A] hover:text-[#3A5544]"
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
